import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'

export const I18N_PRICING_T3_FLAG_NAME = 'prcng-606_v1'

export const trackI18nPricingT3Viewed = () =>
  trackExperimentViewed(I18N_PRICING_T3_FLAG_NAME)

export const useTrackI18nPricingT3Viewed = () => {
  useEffect(() => {
    trackI18nPricingT3Viewed()
  }, [])
}
